import { HTMLProps, ReactElement } from 'react';
import cx from 'classnames';

import BottomSheet, { BottomSheetProps } from 'components/BottomSheet';

export type BottomPanel<PanelName = string> = Pick<
  BottomSheetProps,
  'className' | 'closeOnClickBackdrop' | 'fullscreen' | 'title' | 'show' | 'withBackdrop' | 'renderHeader'
> & {
  name: PanelName;
  enabled?: boolean;
  component: ReactElement;
};

export type BottomPanelsProps<PanelName> = Pick<HTMLProps<HTMLElement>, 'className'> & {
  inner?: boolean;
  panels?: BottomPanel<PanelName>[];
  onClose?(name: PanelName): void;
};

function BottomPanels<PanelName extends string>({
  className,
  inner = false,
  panels = [],
  onClose
}: BottomPanelsProps<PanelName>): JSX.Element {
  return (
    <>
      {panels
        .filter(({ enabled = true }) => enabled)
        .map(panel => (
          <BottomSheet
            key={panel.name}
            id={panel.name}
            className={cx(className, panel.className)}
            title={panel.title}
            show={panel.show}
            fullscreen={panel.fullscreen}
            closeOnClickBackdrop={panel.closeOnClickBackdrop}
            blockBodyScroll={!inner}
            withBackdrop={panel.withBackdrop}
            renderHeader={panel.renderHeader}
            unmountOnExit
            onClose={() => onClose?.(panel.name)}
          >
            {panel.component}
          </BottomSheet>
        ))}
    </>
  );
}

export default BottomPanels;
